'use strict';

export { default as UserService } from './user.service';
export { default as isBetatester } from './utilities/betatester.service';

